import React, { useEffect, useRef } from "react";
import "./home.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import MovieList from "../../Components/MovieList/movielist";
import { useSelector } from "react-redux";

const Home = () => {
  const moviesByName = useSelector((state) => state.movies?.moviesByName || []);
  const popularMovies = useSelector((state) => state.movies?.popular || []);
  const topMovies = useSelector((state) => state.movies?.top_rated || []);
  const nowMovies = useSelector((state) => state.movies?.now_playing || []);
  const upcomingMovies = useSelector((state) => state.movies?.upcoming || []);
  const recommendMovieRef = useRef(null);

  const scrollToBottom = () => {
    recommendMovieRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [moviesByName]);

  return (
    <div className="poster">
      <Carousel
        showThumbs={false}
        autoPlay={true}
        transitionTime={3}
        infiniteLoop={true}
        showStatus={true}
      >
        {popularMovies?.map((movie) => (
          <Link
            style={{ textDecoration: "none", color: "white" }}
            to={`/movie/${movie.id}`}
            key={movie.id}
          >
            <div className="posterImage">
              <img
                src={`https://image.tmdb.org/t/p/original${
                  movie && movie.backdrop_path
                }`}
                alt=""
              />
            </div>
            <div className="posterImage__overlay">
              <div className="posterImage__title">
                {movie ? movie.original_title : ""}
              </div>
              <div className="posterImage__runtime flex items-center">
                {movie ? movie.release_date : ""}
                <span className="posterImage__rating">
                  {movie ? (
                    <span className="flex gap-3">
                      {movie.vote_average} <FaStar />
                    </span>
                  ) : (
                    ""
                  )}
                </span>
              </div>
              <div className="posterImage__description sm:flex hidden">
                {movie ? movie.overview : ""}
              </div>
              <div className="posterImage__description sm:hidden flex">
                {movie ? movie.overview?.slice(0, 100) + "..." : ""}
              </div>
            </div>
          </Link>
        ))}
      </Carousel>
      {moviesByName.length !== 0 && moviesByName[0] !== null ? (
        <div ref={recommendMovieRef}>
          <MovieList movies={moviesByName} category={"recommended"} />
        </div>
      ) : null}
      <MovieList movies={nowMovies} category={"Now Playing"} />
      <MovieList movies={topMovies} category={"top rated"} />
      <MovieList movies={popularMovies} category={"popular"} />
      <MovieList movies={upcomingMovies} category={"upcoming"} />
    </div>
  );
};

export default Home;
